import React from 'react';
import { Link } from 'react-router-dom';

export function LayoutMenuHeader(props) {    
    function handleSearch(evt) {
        props.updateSearch(evt.target.value);
    }

    if (!props.menuOpen) {
        return (
            <div className="wis-nav-header">
                <div className="wis-nav-logo-mini">
                    <Link to="/">
                        <span>WIS</span>
                    </Link>
                </div>
                <div className="wis-nav-open-button" onClick={props.openMenu}>
                    <span className="fa fa-cog" />
                </div>
            </div>
        );
    }
    else {
        
        return (
            <div className="wis-nav-header">
                <div className="wis-nav-logo">
                    <Link to="/">
                        <span>WIS 4.0</span>
                    </Link>
                </div>
                <div className="wis-nav-search">
                    <div className="wis-nav-search-field">
                        <input className="wis-nav-search-input" placeholder="Buscar" onChange={handleSearch} />
                    </div>
                </div >
                <div className="wis-nav-close-button" onClick={props.closeMenu}>
                    <span className="fa fa-chevron-left" />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LayoutComponents/LayoutMenuHeader.js